import VideoAutoplay from './videoAutoplay';

let videoAutoplayInstance = null;

document.addEventListener('DOMContentLoaded', () => {
  videoAutoplayInstance = new VideoAutoplay();
});
